import { actionTypes } from "../actions/campaigns";

const variable = (state = null, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CAMPAIGN:
      return action.payload;
    default:
      return state;
  }
};

export default variable;